<div class="mt-5">
  <div>
    <form #personalGoodwillForm="ngForm" novalidate="novalidate">

      <div class="row mt-5 mb-4" *ngIf="currentReport?.LATEST?.RISK && currentReport.LATEST.COMPANY.NAICS.R_PG === false && !currentReport.LATEST.RISK.OPT_PG">
        <div class="col-md-12 text-center">
          Personal Goodwill was deemed a non-factor for the company based on Industry Type.
          <p>Should you wish to determine Personal Goodwill Risk, please click <a role="button" class="color--blue"
              (click)="currentReport.isLocked ? '' : showHidePersonalGoodwill()">here</a>.</p>
        </div>
      </div>

      <div class="row" *ngIf="currentReport?.LATEST?.RISK && (currentReport.LATEST.COMPANY.NAICS.R_PG || currentReport.LATEST.RISK.OPT_PG)">
        <div class="col-md-12">
          <div class="label">
            What would the impact be if the owner or a key employee were to leave?
          </div>

          <div class="row">
            <div class="col-md-12">
              <radio-group-button radioGroupButtonId="risk-pg-owner-leave-type-radio-group" [selectedOption]="currentReport.LATEST.RISK.PG_OWNER_LEAVE"
                [btnList]="goodwillList" [disabled]="currentReport?.isLocked"
                [isButton]="true" (optionChange)="currentReport.LATEST.RISK.PG_OWNER_LEAVE = $event; callUpdateAPI()" [(ngModel)]="currentReport.LATEST.RISK.PG_OWNER_LEAVE"
                #PG_OWNER_LEAVE="ngModel" name="PG_OWNER_LEAVE" required>
              </radio-group-button>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</div>

<report-footer
  [nextBtnEnable]="(currentReport?.LATEST?.RISK && personalGoodwillForm.valid) || currentReport?.isLocked"
  (buttonClicked)="footerButtonClick($event)" [extraBtnText]="'Back to Optional'"
  [extraAvailable]="!currentReport?.isLocked && !currentReport?.LATEST?.COMPANY.NAICS.R_PG && currentReport?.LATEST?.RISK.OPT_PG"
  [skipAvailable]="!currentReport?.isLocked" [skipArrow]="false" [skipBtnText]="'Reset'"
  [pageId]="reportPageConst.PERSONAL_GOODWILL" [mobileIcon]="'reset-icon'"></report-footer>
